// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCollapsibleSection-Content_cls1__sUCxG","cls2":"VeloCollapsibleSection-Content_cls2__RKWzA VeloCollapsibleSection-Content_cls1__sUCxG"};